import { defineComponent as _defineComponent } from 'vue'
import { unref as _unref, isRef as _isRef, createVNode as _createVNode, createElementVNode as _createElementVNode, toDisplayString as _toDisplayString, createTextVNode as _createTextVNode, resolveComponent as _resolveComponent, withCtx as _withCtx, normalizeClass as _normalizeClass, openBlock as _openBlock, createElementBlock as _createElementBlock, pushScopeId as _pushScopeId, popScopeId as _popScopeId } from "vue"

const _withScopeId = n => (_pushScopeId("data-v-ccf75f06"),n=n(),_popScopeId(),n)
const _hoisted_1 = { class: "button-group-item" }
const _hoisted_2 = { class: "button-group-item flex-grow-1 flex-shrink-1 dropdown-button-label" }

import { computed } from 'vue';
import SortButton from '@/components/SortButton.vue';
import { useI18n } from 'vue-i18n';


export default /*#__PURE__*/_defineComponent({
  __name: 'SortingListDropdown',
  props: {
    sortFields: null,
    sortBy: null,
    direction: null,
    disabled: { type: Boolean }
  },
  emits: ["update:direction", "update:sortBy", "change"],
  setup(__props: any, { emit: emits }: { emit: ({
  (e: 'update:direction', value: string): void;
  (e: 'update:sortBy', value: string): void;
  (e: 'change'): void;
}), expose: any, slots: any, attrs: any }) {

const props = __props as {
  sortFields: Record<string, any>[];
  sortBy: string;
  direction: string;
  disabled?: boolean;
}

const { t } = useI18n();





const sortByModel = computed({
  get() {
    return props.sortBy;
  },
  set(field: string) {
    return emits('update:sortBy', field);
  },
});
const directionModel = computed({
  get() {
    return props.direction;
  },
  set(value: string) {
    return emits('update:direction', value);
  },
});

const getLabel = value => {
  return props.sortFields.find(field => field.value === value)?.label;
};

return (_ctx: any,_cache: any) => {
  const _component_Dropdown = _resolveComponent("Dropdown")!

  return (_openBlock(), _createElementBlock("div", null, [
    _createElementVNode("div", {
      class: _normalizeClass(["button-group button-group-base w-full", __props.disabled ? 'disabled' : ''])
    }, [
      _createElementVNode("div", _hoisted_1, [
        _createVNode(SortButton, {
          modelValue: _unref(directionModel),
          "onUpdate:modelValue": _cache[0] || (_cache[0] = ($event: any) => (_isRef(directionModel) ? (directionModel).value = $event : null)),
          onClick: _cache[1] || (_cache[1] = ($event: any) => (emits('change'))),
          disabled: __props.disabled
        }, null, 8, ["modelValue", "disabled"])
      ]),
      _createElementVNode("div", _hoisted_2, [
        _createVNode(_component_Dropdown, {
          modelValue: _unref(sortByModel),
          "onUpdate:modelValue": _cache[2] || (_cache[2] = ($event: any) => (_isRef(sortByModel) ? (sortByModel).value = $event : null)),
          options: __props.sortFields,
          "option-label": "label",
          "option-value": "value",
          placeholder: _unref(t)('sortBy'),
          class: "dropdown-button last",
          "panel-class": "dropdown-list sm:w-8rem mt-s1",
          onChange: _cache[3] || (_cache[3] = ($event: any) => (emits('change'))),
          disabled: __props.disabled
        }, {
          value: _withCtx((slotProps) => [
            _createTextVNode(_toDisplayString(_unref(t)('sortBy')) + " " + _toDisplayString(getLabel(slotProps.value)), 1)
          ]),
          _: 1
        }, 8, ["modelValue", "options", "placeholder", "disabled"])
      ])
    ], 2)
  ]))
}
}

})